export default {
  namespaced: true,
  state:{
    // La API devuelve el período como rango; el estado inicial lo refleja para que la forma
    // sea la misma antes y después de la primera consulta.
    creditBalance: { period: { year: null, from_month: null, to_month: null }, rows: [], summary: {} },
    topProducts: [],
    topClients: []
  },
  getters:{
    creditBalance: state => state.creditBalance,
    topProducts: state => state.topProducts,
    topClients: state => state.topClients
  },
  mutations:{
    SET_CREDIT_BALANCE(state, value){ state.creditBalance = value; },
    SET_TOP_PRODUCTS(state, value){ state.topProducts = value; },
    SET_TOP_CLIENTS(state, value){ state.topClients = value; }
  },
  actions:{
    getCreditBalance({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('stock/reports/credit-balance', { params: payload || {} }).then((response) => {
          commit('SET_CREDIT_BALANCE', response.data.data);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getTopProducts({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('stock/reports/top-products', { params: payload || {} }).then((response) => {
          commit('SET_TOP_PRODUCTS', response.data.data.rows);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    getTopClients({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get('stock/reports/top-clients', { params: payload || {} }).then((response) => {
          commit('SET_TOP_CLIENTS', response.data.data.rows);
          resolve(response);
        }).catch(error => reject(error));
      });
    },
    // La descarga va como blob. El backend responde JSON cuando falla, así que el error
    // también llega como Blob y hay que convertirlo antes de que handleError pueda leerlo:
    // es el mismo patrón que ya usa LoggroDownloadReport.
    downloadCreditBalance(_, payload) {
      return new Promise((resolve, reject) => {
        axios({ url: 'stock/reports/credit-balance/download', method: 'GET',
                params: payload || {}, responseType: 'blob' })
          .then(response => {
            const objeto = window.URL.createObjectURL(new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }));
            const link = document.createElement('a');
            link.href = objeto;

            const disposition = response.headers['content-disposition'];
            let filename = 'Saldo_A_Favor.xlsx';
            if (disposition) {
              const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
              if (match && match[1]) filename = match[1].replace(/['"]/g, '');
            }

            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(objeto);
            resolve(response);
          })
          .catch(async error => {
            if (error.response && error.response.data instanceof Blob) {
              try {
                const texto = await error.response.data.text();
                error.response.data = JSON.parse(texto);
              } catch (e) {
                console.error('Error no es JSON válido');
              }
            }
            reject(error);
          });
      });
    }
  }
}
